import React from "react";
import Modal from "react-bootstrap/Modal";
import { Button, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Lesson } from "../../common/api";
import { AppAnchor } from "../../common/CommonStyles";

export const PrintablesModal = ({
  lesson,
  show,
  onHide,
}: {
  lesson: Lesson;
  show: boolean;
  onHide: () => void;
}) => {
  const { t } = useTranslation();
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>{t("printables_title")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {lesson.downloadable_materials.map((downloadableMaterial, index) => (
          <Row
            key={downloadableMaterial.id}
            className={
              index === lesson.downloadable_materials.length - 1 ? "" : "mb-3"
            }
          >
            <AppAnchor href={downloadableMaterial.url}>
              {downloadableMaterial.title}
            </AppAnchor>
          </Row>
        ))}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          {t("printables_close")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
